export default __webpack_public_path__ + "static/char-s-09-en-0445d8d0367032834ce412a4169c49e9.png";